import * as logging from "../utils/log";

"use strict";

let _tokenID : string = null;
let _webID : string | number = null;
let _url : string = null;

export function init(baseURL : string, tokenID : string, webID : string | number)
{
	_url = baseURL;
	_tokenID = tokenID;
	_webID = webID;
	logging.log("WebAPI2", "Initialized", _url, _tokenID, _webID);
}

export function get(method : string, data : {[key : string] : any}, logLevel : "normal" | "minimal" | "none" = "none")
{
	return call(method, data, {method: "GET", logLevel});
}

export function post(method : string, data : {[key : string] : any}, logLevel : "normal" | "minimal" | "none" = "none")
{
	return call(method, data, {method: "POST", logLevel});
}

export function call(call : string, data : {[key : string] : any}, params : any)
{
	if (!_url) {
		throw new Error("[WebAPI2] URL Not set");
	}

	const logLevel = params.logLevel || "none";
	const method = params.method || "GET";

	if (logLevel === "normal") {
		logging.log("WebAPI", "Request:", call, data);
	} else if (logLevel === "minimal") {
		logging.log("WebAPI", "Request:", call);
	}

	return new Promise((resolve, reject) =>
	{
		$.ajax({
			type: method,
			url: `${_url}${call}?` + $.param({ tokenID: _tokenID }),
			data: data,
			crossDomain: true,
			dataType: "text",
			success: (response : string) =>
			{
				try {
					response = $.parseJSON(response);

					if (logLevel === "normal") {
						logging.debug("WebAPI", "Response", response);
					}

					resolve(response);

				} catch (e) {
					logging.error("WebAPI2", "Failed to parse JSON from calling '" + call + "' with data " + JSON.stringify(data) + " Response is:", response);
					logging.errorOnly("WebAPI2", "Error: ", e);
					reject("Failed to parse JSON from calling '" + call);
				}
			},
			error: (...args : any[]) =>
			{
				logging.error("Failed to call WebAPI2", ...args);
				reject();
			}
		});
	});
}

const webAPI = {init, get, post, call};
export default webAPI;
